/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  CardContent,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
  Button,
  Combobox,
  DatePicker,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Textarea,
  cn,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { showToast } from "utils/helper";
import {
  useConfirmDispatchOrders,
  useDownloadDispatchDiscrepancy,
  useGetDispatchedRoutes,
  useGetOutgoingOrders,
} from "utils/apis/home.api";
import { UserContext } from "utils/reducers/user";
import { formatDate } from "date-fns";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { CheckCircle, LucideFileOutput, View } from "lucide-react";
import { useGetContainersDiscrepancy } from "utils/apis/lookups.api";
import RouteDispatchReportGenerator from "./routeDispatchReport";

export default function LoadingBayDispatch() {
  const currentDate = new Date();
  const user = useContext(UserContext);

  const [ddlRoutes, setDdlRoutes] = useState("");
  const [packagesConsignments, setPackagesConsignments] = useState<any>([]);
  const [consignment, setConsignment] = useState<any>(null);
  const [coinsConsignments, setCoinsConsignments] = useState<any>([]);
  const [operationDate, setOperationDate] = useState(currentDate);
  const [verificationType, setVerificationType] = useState("");
  const [description, setDescription] = useState("");
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [visible, setVisible] = useState(false);

  const { data: routes } = useGetDispatchedRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: containersDiscrepancyReason } =
    useGetContainersDiscrepancy("Dispatching");

  const {
    refetch,
    data: outgoingOrders,
    isFetching: loadingRequests,
  } = useGetOutgoingOrders({
    cashCenterId: user.CashCenterId,
    routeNo: ddlRoutes,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  useEffect(() => {
    if (
      outgoingOrders?.coinsBoxes?.length ||
      outgoingOrders?.sealedPackages?.length
    ) {
      setPackagesConsignments(
        outgoingOrders?.sealedPackages?.map((i) => ({
          ...i,
          clientVerification: false,
        })),
      );
      setCoinsConsignments(
        outgoingOrders?.coinsBoxes?.map((i) => ({
          ...i,
          id: crypto.randomUUID(),
          clientVerification: false,
        })),
      );
    }
    if (
      !outgoingOrders?.sealedPackages?.length &&
      !outgoingOrders?.coinsBoxes?.length
    ) {
      setPackagesConsignments([]);
      setCoinsConsignments([]);
    }
  }, [outgoingOrders]);

  const onDdlRoutesChanged = (value: string) => {
    setDdlRoutes(value);
    if (!value) {
      setDdlRoutes("");
      setPackagesConsignments([]);
      setCoinsConsignments([]);
    }
  };

  const onOperationDateChanged = (date?: Date) => {
    if (date) setOperationDate(date);
    setDdlRoutes("");
  };

  const handleValidationModal = (item: any, type: string) => {
    setVerificationType(type);
    setConsignment(item);
    setVisible(true);
  };

  const {
    mutate: dispatchOrders,
    isSuccess: dispatchOrdersSuccess,
    isPending: dispatchOrdersPending,
  } = useConfirmDispatchOrders();

  const {
    mutate: dispatchDiscrepancyReport,
    data: dispatchDiscrepancyData,
    isPending: dispatchDiscrepancyPending,
  } = useDownloadDispatchDiscrepancy();

  const onConfirmDispatchBtnClicked = () => {
    dispatchOrders({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
      shift: "morning",
      consignments: packagesConsignments?.map(
        ({ clientVerification, ...i }: any) => ({
          ...i,
          isValidated: i.isValidated ? true : clientVerification,
        }),
      ),
      coinsBoxes: coinsConsignments?.map(
        ({ clientVerification, id, ...i }: any) => ({
          ...i,
          isValidated: i.isValidated ? true : clientVerification,
        }),
      ),
    });
  };

  const onDownloadReport = () => {
    if (!ddlRoutes) showToast("error", "Select Route No.");
    dispatchDiscrepancyReport({
      cashCenterId: user.CashCenterId,
      shift: "morning",
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
    });
  };

  const onConfirmValidation = (item: any) => {
    if (!description) return showToast("error", "Select issue first.");
    if (!reason) return showToast("error", "Select issue description first.");

    if (verificationType === "coins") {
      setCoinsConsignments((prev: any) => {
        return prev?.map((i: any) =>
          i.id === item.id
            ? {
                ...item,
                reason,
                description,
                remarks,
                clientVerification: true,
              }
            : { ...i },
        );
      });
    } else {
      setPackagesConsignments((prev: any) => {
        return prev?.map((i: any) =>
          i.sealNo === item.sealNo
            ? {
                ...item,
                reason,
                description,
                remarks,
                clientVerification: true,
              }
            : {
                ...i,
              },
        );
      });
    }

    setVisible(false);
    setDescription("");
    setReason("");
    setRemarks("");
  };

  useEffect(() => {
    if (dispatchOrdersSuccess) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refetch();
    }
  }, [dispatchOrdersSuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Loading Bay Dispatching</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex mt-3 gap-2">
            <DatePicker
              selectedDate={operationDate}
              onSelectDate={onOperationDateChanged}
              placeholder="Select Date"
            />
            <div className="w-full">
              <Combobox
                value={ddlRoutes}
                data={routes?.map((route) => ({
                  value: route.routeNo,
                  label: `${route.routeNo} (${route.description})`,
                }))}
                placeholder="Select Route"
                setValue={onDdlRoutesChanged}
              />
            </div>
            <Button
              variant="secondary"
              className="max-w-[200px] w-full"
              onClick={onConfirmDispatchBtnClicked}
              isLoading={dispatchOrdersPending}
            >
              Save
            </Button>

            <Button
              variant="secondary"
              className="max-w-[200px] w-full"
              isLoading={dispatchDiscrepancyPending}
              onClick={onDownloadReport}
            >
              <LucideFileOutput /> Download
            </Button>
            {dispatchDiscrepancyData ? (
              <RouteDispatchReportGenerator data={dispatchDiscrepancyData} />
            ) : null}
          </div>
          <div className="border-b my-3 bg-accent" />
          {loadingRequests ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : null}
          <div className="flex gap-3">
            <div className="flex-[0.5]">
              <h4 className="font-semibold text-lg mb-3">Packages</h4>
              {packagesConsignments?.length ? (
                <Grid data={packagesConsignments}>
                  <GridColumn field="containerType" title="Container" />
                  <GridColumn field="sealNo" title="Seal No." />
                  <GridColumn field="discrepancyType" title="Discrepancy" />
                  <GridColumn
                    title="Status"
                    field="isValidated"
                    cell={({ field, dataItem }) => {
                      return (
                        <td>
                          {field && dataItem[field] ? (
                            <span className="text-green-500">Successful</span>
                          ) : (
                            <span className="text-red-500">Discrepancy</span>
                          )}
                        </td>
                      );
                    }}
                  />
                  <GridColumn
                    field="isValidated"
                    title="Action"
                    cell={({ field, dataItem }) => (
                      <td>
                        {field && !dataItem[field] ? (
                          <Button
                            variant="outline"
                            className={cn(
                              "text-white hover:text-black",
                              dataItem?.clientVerification
                                ? "bg-green-500"
                                : "bg-red-500",
                            )}
                            onClick={() => {
                              handleValidationModal(dataItem, "packages");
                            }}
                          >
                            <CheckCircle />
                          </Button>
                        ) : (
                          <Button
                            variant="secondary"
                            onClick={() => {
                              handleValidationModal(dataItem, "view");
                            }}
                          >
                            <View />
                          </Button>
                        )}
                      </td>
                    )}
                  />
                </Grid>
              ) : null}
            </div>
            <div className="flex-[0.5]">
              <h4 className="font-semibold text-lg mb-3">Coins</h4>
              {coinsConsignments?.length ? (
                <Grid data={coinsConsignments}>
                  <GridColumn field="containerType" title="Container" />
                  <GridColumn field="denomination" title="Denomination" />
                  <GridColumn field="count" title="Expected" />
                  <GridColumn field="receivedCount" title="Actual" />
                  <GridColumn field="discrepancyType" title="Discrepancy" />
                  <GridColumn
                    title="Status"
                    field="isValidated"
                    cell={({ field, dataItem }) => {
                      return (
                        <td>
                          {field && dataItem[field] ? (
                            <span className="text-green-500">Successful</span>
                          ) : (
                            <span className="text-red-500">Discrepancy</span>
                          )}
                        </td>
                      );
                    }}
                  />
                  <GridColumn
                    field="isValidated"
                    title="Action"
                    cell={({ field, dataItem }) => (
                      <td>
                        {field && !dataItem[field] ? (
                          <Button
                            variant="outline"
                            className={cn(
                              "text-white hover:text-black",
                              dataItem?.clientVerification
                                ? "bg-green-500"
                                : "bg-red-500",
                            )}
                            onClick={() => {
                              handleValidationModal(dataItem, "coins");
                            }}
                          >
                            <CheckCircle />
                          </Button>
                        ) : (
                          <Button
                            variant="secondary"
                            onClick={() => {
                              handleValidationModal(dataItem, "view");
                            }}
                          >
                            <View />
                          </Button>
                        )}
                      </td>
                    )}
                  />
                </Grid>
              ) : null}
            </div>
          </div>

          <Dialog
            open={visible}
            onOpenChange={(val) => {
              setDescription("");
              setReason("");
              setRemarks("");
              setVisible(val);
            }}
          >
            <DialogContent className="max-w-[760px]">
              <DialogHeader>
                <DialogTitle>
                  {verificationType === "view"
                    ? "Validation Detail"
                    : "Validate Bag"}
                </DialogTitle>
              </DialogHeader>
              <DialogDescription className="pt-6 text-black">
                <div className="flex gap-3 flex-wrap">
                  <div className="flex gap-2 w-[calc(50%_-_8px)]">
                    <strong>Route:</strong>
                    <span>{outgoingOrders?.routeNo}</span>
                  </div>
                  <div className="flex gap-2 w-[calc(50%_-_8px)]">
                    <strong>Team Leader:</strong>
                    <span>
                      {outgoingOrders?.teamLeaderName} (
                      {outgoingOrders?.teamLeaderId})
                    </span>
                  </div>
                  {consignment?.sealNo ? (
                    <div className="flex gap-2 w-[calc(50%_-_8px)]">
                      <strong>Seal No:</strong>
                      <span>{consignment?.sealNo}</span>
                    </div>
                  ) : null}
                  <div className="w-full flex gap-2 items-center">
                    <strong className="w-[30%]">
                      Issue
                      {verificationType === "view" ? (
                        ":"
                      ) : (
                        <sup className="text-red-500">*</sup>
                      )}
                    </strong>
                    {verificationType === "view" ? (
                      consignment?.description
                    ) : (
                      <Select
                        onValueChange={setDescription}
                        value={description}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Select Issue Type" />
                        </SelectTrigger>
                        <SelectContent>
                          {containersDiscrepancyReason?.map((item: any) => (
                            <SelectItem
                              key={item.description}
                              value={item.description}
                            >
                              {item.description}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    )}
                  </div>
                  <div className="w-full flex gap-2 items-center">
                    <strong className="w-[30%]">
                      Issue Description
                      {verificationType === "view" ? (
                        ":"
                      ) : (
                        <sup className="text-red-500">*</sup>
                      )}
                    </strong>
                    {verificationType === "view" ? (
                      consignment?.reason
                    ) : (
                      <Select onValueChange={setReason} value={reason}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Reason" />
                        </SelectTrigger>
                        <SelectContent>
                          {containersDiscrepancyReason
                            ?.find((item) => item.description === description)
                            ?.subReasons?.map((item: any) => (
                              <SelectItem
                                key={item.description}
                                value={item.description}
                              >
                                {item.description}
                              </SelectItem>
                            ))}
                        </SelectContent>
                      </Select>
                    )}
                  </div>
                  <div className="w-full flex gap-2 items-center">
                    <strong className="w-[30%]">Remarks</strong>
                    {verificationType === "view" ? (
                      consignment?.remarks
                    ) : (
                      <Textarea
                        value={remarks}
                        onChange={(e) => {
                          setRemarks(e.target.value);
                        }}
                      />
                    )}
                  </div>
                </div>
                {verificationType !== "view" && (
                  <div className="flex justify-end gap-3 mt-3">
                    <Button
                      variant="outline"
                      onClick={() => {
                        setVisible(false);
                        setDescription("");
                        setReason("");
                        setRemarks("");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        onConfirmValidation(consignment);
                      }}
                    >
                      Validate
                    </Button>
                  </div>
                )}
              </DialogDescription>
            </DialogContent>
          </Dialog>
        </CardContent>
      </Card>
    </Layout>
  );
}
